import { EMBED_UA_TOKEN, type EmbedMessage } from '@pingo/shared';

/**
 * The web inside the PinGo app's in-app web screen (CLAUDE.md §15 #402): the app adds
 * `PinGoApp/<version>` to the WebView user agent and injects `window.ReactNativeWebView`.
 * Ordinary browsers (and other apps' WebViews) are never embedded.
 */
interface RnWebView {
  postMessage(message: string): void;
}

function bridge(w: Window = window): RnWebView | null {
  const rn = (w as Window & { ReactNativeWebView?: RnWebView }).ReactNativeWebView;
  return rn && typeof rn.postMessage === 'function' ? rn : null;
}

const UA_RE = new RegExp(`\\b${EMBED_UA_TOKEN}/\\S+`);

export function isEmbeddedApp(
  ua: string | null | undefined = typeof navigator === 'undefined' ? '' : navigator.userAgent,
  w: Window | undefined = typeof window === 'undefined' ? undefined : window,
): boolean {
  return !!ua && UA_RE.test(ua) && !!w && bridge(w) !== null;
}

/** send a message to the app; false outside the app (the caller falls back to the browser way) */
export function postToApp(message: EmbedMessage): boolean {
  if (!isEmbeddedApp()) return false;
  try {
    bridge()!.postMessage(JSON.stringify(message));
    return true;
  } catch {
    return false;
  }
}
